<template>
	<div class="contact column">
		<div class="header-container full-width contact-header">
			<div class="header-title-box">
				<h1>Skontaktuj się z nami</h1>
			</div>
		</div>
		<address class="contact-box column">
			<div class="c-box-title">Kontakt:</div>
			<div class="c-box-details column">
				<div class="column">
					<div class="c-item">
						<span class="c-label">
							<font-awesome-icon :icon="['fas', 'mobile-alt']" />
						</span>
						<a href="tel:+48690001153">+48 690 00 11 53</a> /
						<a href="tel:+48793727242">+48 793 72 72 42</a>
					</div>
					<div class="c-item">
						<span class="c-label">
							<font-awesome-icon :icon="['fas', 'at']" />
						</span>
						<a href="mailto:biuro@macikowska.pl"
							>biuro@macikowska.pl</a
						>
					</div>
				</div>
			</div>
			<div class="c-box-title">Adres:</div>
			<div class="c-box-details column">
				<span class="bold">Biuro:</span>
				<span>Wschodnia 2</span>
				<span>66-100 Sulechów</span>
			</div>
			<div class="c-box-title">Informacje VAT:</div>
			<div class="c-box-details  column">
				<div>
					<span class="bold">NIP: </span>
					<span>9731063818</span>
				</div>
				<div>
					<span class="bold">REGON: </span>
					<span>383067964</span>
				</div>
			</div>
		</address>
	</div>
</template>

<script>
export default {
	metaInfo: {
		title:
			'Kontakt - Obsługa księgowa Sulechów - Biuro Rachunkowe Joanna Macikowska',
		meta: [
			{
				itemprop: 'name',
				content:
					'Kontakt - Obsługa księgowa Sulechów - Biuro Rachunkowe Joanna Macikowska',
			},
			{
				itemprop: 'description',
				content:
					'Sulechów Biuro Rachunkowe - Kontakt: tel. 690 00 11 53',
			},
			{
				itemprop: 'image',
				content: 'https://macikowska.pl/site_img.jpeg',
			},
			{
				property: 'og:title',
				content: 'Kontakt - Biuro Rachunkowe Joanna Macikowska',
			},
			{ property: 'og:site_name', content: 'macikowska.pl' },
			// The list of types is available here: http://ogp.me/#types
			{ property: 'og:type', content: 'website' },
			// Should the the same as your canonical link, see below.
			{
				property: 'og:url',
				content: 'https://macikowska.pl/kontakt',
			},
			{
				property: 'og:image',
				content: 'https://macikowska.pl/site_img.jpeg',
			},
			// Often the same as your meta description, but not always.
			{
				property: 'og:description',
				content: 'Obłsuga księgowa firm na najwyższym poziomie',
			},
		],
	},
}
</script>

<style lang="scss">
@include media-breakpoint-up(xs) {
	.contact-header {
		background: $main-dark;
		color: #fff;
		@include standard-header;
	}
	.c-box-title {
		font-size: 1.7em;
		font-weight: 100;
	}
	.c-box-details {
		margin: 1em 0;
	}
	.c-label {
		margin-right: 10px;
	}
}
@include media-breakpoint-up(sm) {
}
@include media-breakpoint-up(md) {
}
@include media-breakpoint-up(lg) {
}
@include media-breakpoint-up(xl) {
}

.contact-box {
	margin: 3em auto;
}
</style>
